import React from 'react';
import {motion} from "framer-motion";
import profilePhoto from '../assets/BZ5_7638.jpg';
import {PrimaryButton} from '../ui/Button';
import {Badge} from '../ui/Badge';


const HeroBanner: React.FC = () => {
    return (
        <header id="home" className="hero-banner">
            <div className="container hero-grid">
                <div className="hero-content">
                    <h1 className="hero-title">
                        <motion.span
                            initial={{fontWeight: 400}}
                            whileHover={{fontWeight: 800}}
                            transition={{duration: 0.4}}
                        >
                            Запуск и развитие
                        </motion.span>
                        <br/>
                        <motion.span className="accent section-title"
                                     initial={{fontWeight: 400}}
                                     whileHover={{fontWeight: 800}}
                                     transition={{duration: 0.4}}
                        >
                            <strong>цифровых продуктов</strong>
                        </motion.span>
                    </h1>
                    <p className="hero-description section-title text-left mt-small">
                        Senior-разработчик с 10 годами коммерческого опыта в ведущих медиа IT-компаниях
                        (<strong>Газпром-Медиа, Иви, Билайн</strong>),
                        а так же в сферах ритейла, ресторанного бизнеса и госсекторе

                    </p>
                    <p className="hero-description">
                        Беру на себя технику, архитектуру и запуск —
                        вы получаете результат, а не головную боль.
                    </p>

                    <div className="trust-bar">
                        <span> 10+ лет в коммерческой разработке</span>
                        <span className="separator">•</span>
                        <span>Работаю напрямую</span>
                        <span className="separator">•</span>
                        <span>Фиксирую задачи, сроки и результат</span>
                        <span className="separator">•</span>
                        <span>Ориентируюсь на пользу для бизнеса</span>
                    </div>

                    <PrimaryButton href="#contact">Связаться со мной</PrimaryButton>
                </div>

                <div className="hero-visual">
                    <div className="glass-frame">
                        <div className="inner-glow"></div>
                        <img className="profile-photo-main" src={profilePhoto} alt="Профиль"/>

                        <Badge>
                            <div className="stack-list">Backend · Web · Mobile · AI</div>
                        </Badge>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default HeroBanner;
